import React,{useState} from "react";
import { useParams } from "react-router-dom";
import client from "../../../api";
import { notifyError, notifySuccess } from "../../../helper";

const EditCampaignNameModelWindow = (props) => {
    const {name, setDisplayEditNameModelWindow, displayEditNameModelWindow } = props;
    const api = client();
    const {campaignID} = useParams('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [campaignName, setCampaignName] = useState(name);
    const handleInputField = (value) => {
        setCampaignName(value);
    }
    
    const onFocus = (e) => {
        setError('');
    }

    const onBlur = (e) => {
        if(!e.target.value.length){
            setError("This field cannot be empty.");
        }        
    }

    const updateCampaignName = async () => {
        if(!campaignName.length){
            setError("This field cannot be empty.");
            return;
        }
        try{
            setLoading(true);
            const payload = {
                id: campaignID,
                name: campaignName, 
            }
            
            const response = await api.post('/v1/campaign/update', payload);
            if(response.status === 200 || response.status === 201){
                notifySuccess('Campaign Title updated successfully');
                setLoading(false);
                setTimeout(()=>{
                    window.location.reload();
                },1500);
            }                
        } catch(error){
            console.log('error.message',error);
            setLoading(false);
            if(error.status === 400) notifyError('Bad Request. Not able to fetch Campaign Overview');
        }
    }
    
    return(<>
        <div className="model-window">
            <div className="overlay"></div>
            <div className="model-view">
                <div className="inner-view">
                    <h2>Edit title</h2>
                    <p>This modal allows to modify the campaign title with options to save or cancel changes.</p>
                    <div className="form-fields">
                        <div className="field-wrap">
                            <label className="label-xs">Campaign Title</label>
                            <input 
                                type="text" 
                                name="campaign-name" 
                                onChange={(e)=>{
                                    handleInputField(e.target.value)}
                                }
                                onFocus={onFocus} 
                                onBlur={onBlur}
                                value={campaignName}
                                />

                            {error ? <span className="validation-error">{error}</span> :''}

                        </div>
                    </div>
                    <div className="button-group">
                        <button 
                            type="button" 
                            className={loading ? "next-btn button--loading":"next-btn"} 
                            disabled={loading}
                            onClick={()=>updateCampaignName()}>
                                <span className="button--text">Save</span>
                        </button>
                        
                        <button className="cancel-btn" onClick={()=>setDisplayEditNameModelWindow(!displayEditNameModelWindow)}>Cancel</button>
                    </div>
                </div>
            </div>
        </div>
    </>);
}

export default EditCampaignNameModelWindow;